const actions = {
  SET_STATE: 'user/SET_STATE',
  PROFILE_UPDATE: 'user/PROFILE_UPDATE',
  PASSWORD_UPDATE: 'user/PASSWORD_UPDATE',
  REFRESH_ERRORS: 'user/REFRESH_ERRORS',
  FETCH_ALL: 'user/FETCH_ALL',
  DETAILS: 'user/DETAILS',
  ADD: 'user/ADD',
  EDIT: 'user/EDIT',
  REMOVE: 'user/REMOVE'
};

export default actions
